
jQuery(document).ready(function($){




  

  $('li.menu-link').each(function() {
        if ($(this).find('ul.sub-children-menu').length > 0) {
            $(this).addClass('submenu_parent_custom');
        }
    });

$('.right-cards .slider_section_inner').slick({
  dots: false,
  arrow: true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
            nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
            responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow:4,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});


const $section = $('.slick_slider_category');
  const $slider = $section.find('grid-custom.collection-list--grid');

  $section.css({
    opacity: 0,
    transition: 'opacity 0.5s ease-in-out'
  });

  // Listen for slick init OR reinit
  $slider.on('init reInit', function(event, slick) {
    $section.css('opacity', 1);
  });

if ($(window).width() > 767) {
$('.slick_slider_category grid-custom.collection-list--grid, .slider_section_inner').slick({
  dots: false,
  arrow: true,
  infinite: false,
  speed: 300,
  slidesToShow: 8,
  slidesToScroll: 1,
  prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
            nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>"
});

}

if ($(window).width() < 767) {
$('.slick_slider_category grid-custom.collection-list--grid').slick({
  dots: false,
  arrow: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  rows: 2,
  prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
            nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>"
});
}
  
  

//    if ($(window).width() < 767) {



//             const swiper = new Swiper('.homepage_collection_section .swiper', {
//   slidesPerView: 4,
//   spaceBetween: 25,
//   grid: {
//     rows: 2,
//     fill: 'row'
//   },
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev'
//   },
//   breakpoints: {
//     0: {
//       slidesPerView: 2,
//       grid: {
//         rows: 2
//       }
//     },
//     768: {
//       slidesPerView: 2,
//       grid: {
//         rows: 2
//       }
//     },
//     1200: {
//       slidesPerView: 2,
//       grid: {
//         rows: 2
//       }
//     }
//   }
// });
//         }





  // Sticky buy now button code 

// $(".product-form__buttons .btn-checkout-dynamic.w-full").clone().appendTo("sticky-add-cart .product-form__buttons")

  // end code 

// $("product-bought-together#product-bought-together").insertAfter(".main-product .product-detail__information ul.product-detail__meta");

// $("product-bought-together#product-bought-together").insertAfter(".main-product .product-detail__information .feature-product-form");

setTimeout(function () {
    $("div#frequently-bought-together-app-block")
        .appendTo("#frequently_buy_main");
}, 100);


// frequently buy product price under cards 

  function mapPrices() {

    // Prevent duplicate appending
    $("ul.cbb-frequently-bought-products li .fbp-price-box").remove();

    $("ul.cbb-frequently-bought-selector-list li").each(function(index) {

      let regular   = $(this).find(".cbb-frequently-bought-selector-label-regular-price").text().trim();
      let sale      = $(this).find(".cbb-frequently-bought-selector-label-sale-price").text().trim();
      let compare   = $(this).find(".cbb-frequently-bought-selector-label-compare-at-price").text().trim();

      let targetLi = $("ul.cbb-frequently-bought-products li").eq(index);

      // Create wrapper
      let priceBox = $('<div class="fbp-price-box"></div>');

      // CONDITION: sale available → show sale + compare
      if (sale) {
        priceBox.append(`<span class="fbp-sale-price">${sale}</span>`);

        if (compare) {
          priceBox.append(`<s class="fbp-compare-price">${compare}</s>`);
        }

      } else {
        // No sale → show only regular
        if (regular) {
          priceBox.append(`<span class="fbp-regular-price">${regular}</span>`);
        }
      }

      // Append only if something exists
      if (priceBox.html().trim().length > 0) {
        targetLi.append(priceBox);
      }

    });
  }

  /* ---------------------------------------------------
     MUTATION OBSERVER — Wait until app inserts the HTML
  ------------------------------------------------------ */

  const targetNode = document.body;
  const observer = new MutationObserver(function(mutations) {

    if ($("ul.cbb-frequently-bought-selector-list li").length > 0) {
      observer.disconnect();        // Stop observing once found
      setTimeout(mapPrices, 150);   // Delay ensures CBB finished injecting HTML
    }

  });

  observer.observe(targetNode, { childList: true, subtree: true });

// end of frequently buy product






$('.aboutpage_stand_section .sec__icon-box-inner').slick({
  dots: true,
  arrow: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


 $(".banner_card_item").addClass("slide_in slideIn");
 })
 



// // amit
// jQuery(document).ready(function($){
    // $(".banner_card_item").addClass("slide_in slideIn");
//     });



   


function goToCheckout(variantId) {
  // Find the current selected variant id
  var selectedVariant = document.querySelector('[name="id"]:checked, [name="id"][type="hidden"], select[name="id"]');
  if (selectedVariant && selectedVariant.value) {
    variantId = selectedVariant.value;
  }

  // Make an AJAX POST request to add the product to cart first
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(response => response.json())
  .then(data => {
    // Once added, go to checkout
    window.location.href = '/checkout';
  })
  .catch(error => {
    console.error('Buy Now error:', error);
    alert('Something went wrong. Please try again.');
  });
}

// 

// $('product-recommendations').slick({
//   dots: false,
//   arrow: false,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 4,
//   slidesToScroll: 4,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         infinite: true,
//         dots: true
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
    
//   ]
// });








  const checkbox = document.querySelector('.recipient-form input[type="checkbox"]');
const targetDiv = document.querySelector('.recipient-fields'); // change this to your div selector

checkbox.addEventListener('change', function () {
  if (this.checked) {
    targetDiv.classList.add('active');   // class to add
  } else {
    targetDiv.classList.remove('active'); // remove when unchecked
  }
});